import BinCheckConfig from "./BinCheckConfig";

export default BinCheckConfig;
